import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProgressFeedback  {
    _originalTypeClassName = "zERP.BO.ProgressFeedback";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProgressFeedback.translate = translateService;
}
this.FeedbackType = null;
this.Message = null;
this.Min = null;
this.Max = null;
this.Progress = null;
this.DiscreteMin = null;
this.DiscreteMax = null;
this.DiscreteProgress = null;
this.ProgressFeedbackKey = null;
this._key = this.ProgressFeedbackKey = 0; 
}

static translate: TranslateService;
_key: any;
FeedbackType:any;
Message:any;
Min:any;
Max:any;
Progress:any;
DiscreteMin:any;
DiscreteMax:any;
DiscreteProgress:any;
private _ProgressFeedbackKey:any;
get ProgressFeedbackKey(): any {
    return this._ProgressFeedbackKey;
  }
set ProgressFeedbackKey(value: any) {
    this._ProgressFeedbackKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ProgressFeedbackKey == null || $this.ProgressFeedbackKey == 0;
            }


}